"use strict";
export var ExploreTab = /* @__PURE__ */ ((ExploreTab2) => {
  ExploreTab2["Tokens"] = "tokens";
  ExploreTab2["Pools"] = "pools";
  ExploreTab2["Transactions"] = "transactions";
  return ExploreTab2;
})(ExploreTab || {});
